import ReservationBusinessDayTypeClass from "../../../domain/reservation/ReservationBusinessDayTypeClass";
import ReservationBusinessTime         from "../../../domain/reservation/ReservationBusinessTime";
import ReservationSetting              from "../../../domain/reservation/ReservationSetting";
import ReservationSpecialBusinessTime  from "../../../domain/reservation/ReservationSpecialBusinessTime";
import ReservationTimeTypeClass        from "../../../domain/reservation/ReservationTimeTypeClass";
import {
  ACTION_TYPE,
  BusinessDayTypeSetAction,
  BusinessTimeFromSetAction,
  BusinessTimeToSetAction,
  BusinessTimeTypeSetAction,
  ReservationSettingAction,
  ReservationSettingSetAction,
  SpecialBusinessDateSetAction,
  SpecialBusinessDayTypeSetAction,
  SpecialBusinessTimeFromSetAction, SpecialBusinessTimeAddAction,
  SpecialBusinessTimeToSetAction, SpecialBusinessTimeDeleteAction
} from "./ReservationSettingAction";

const reservationSettingReducer = (state: ReservationSetting = new ReservationSetting(), action: ReservationSettingAction): ReservationSetting => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_RESERVATION_SETTING:
      const setReservationSettingAction: ReservationSettingSetAction = action as ReservationSettingSetAction;
      return setReservationSettingAction.reservationSetting;

    case ACTION_TYPE.ON_CHANGE_BUSINESS_TIME_TYPE:
      return reduceBusinessTimeType(state, action as BusinessTimeTypeSetAction);

    case ACTION_TYPE.ON_CHANGE_BUSINESS_DAY_TYPE:
      return reduceBusinessDayType(state, action as BusinessDayTypeSetAction);

    case ACTION_TYPE.ON_CHANGE_BUSINESS_TIME_FROM:
      return reduceBusinessTimeFrom(state, action as BusinessTimeFromSetAction);

    case ACTION_TYPE.ON_CHANGE_BUSINESS_TIME_TO:
      return reduceBusinessTimeTo(state, action as BusinessTimeToSetAction);

    case ACTION_TYPE.ADD_SPECIAL_BUSINESS_TIME:
      return reduceAddSpecialBusinessTime(state, action as SpecialBusinessTimeAddAction);

    case ACTION_TYPE.DELETE_SPECIAL_BUSINESS_TIME:
      return reduceSpecialBusinessTimeDelete(state, action as SpecialBusinessTimeDeleteAction);

    case ACTION_TYPE.ON_CHANGE_SPECIAL_BUSINESS_DAY_TYPE:
      return reduceSpecialBusinessDayType(state, action as SpecialBusinessDayTypeSetAction);

    case ACTION_TYPE.ON_CHANGE_SPECIAL_BUSINESS_DATE:
      return reduceSpecialBusinessDate(state, action as SpecialBusinessDateSetAction);

    case ACTION_TYPE.ON_CHANGE_SPECIAL_BUSINESS_TIME_FROM:
      return reduceSpecialBusinessTimeFrom(state, action as SpecialBusinessTimeFromSetAction);

    case ACTION_TYPE.ON_CHANGE_SPECIAL_BUSINESS_TIME_TO:
      return reduceSpecialBusinessTimeTo(state, action as SpecialBusinessTimeToSetAction);
  }
};

const reduceBusinessTimeType = (state: ReservationSetting, action: BusinessTimeTypeSetAction): ReservationSetting => {
  return new ReservationSetting(new ReservationTimeTypeClass(action.timeType), state.businessTimes, state.specialBusinessTimes);
};

const reduceBusinessDayType = (state: ReservationSetting, action: BusinessDayTypeSetAction): ReservationSetting => {
  const target: ReservationBusinessTime = state.businessTimes.findByWeekType(action.weekType);
  return new ReservationSetting(
    state.timeType,
    state.businessTimes.replace(new ReservationBusinessTime(target.weekType, new ReservationBusinessDayTypeClass(action.dayType), target.from, target.to)),
    state.specialBusinessTimes
  );
};

const reduceBusinessTimeFrom = (state: ReservationSetting, action: BusinessTimeFromSetAction): ReservationSetting => {
  const target: ReservationBusinessTime = state.businessTimes.findByWeekType(action.weekType);
  return new ReservationSetting(
    state.timeType,
    state.businessTimes.replace(new ReservationBusinessTime(target.weekType, target.dayType, action.from, target.to)),
    state.specialBusinessTimes
  );
};

const reduceBusinessTimeTo = (state: ReservationSetting, action: BusinessTimeToSetAction): ReservationSetting => {
  const target: ReservationBusinessTime = state.businessTimes.findByWeekType(action.weekType);
  return new ReservationSetting(
    state.timeType,
    state.businessTimes.replace(new ReservationBusinessTime(target.weekType, target.dayType, target.from, action.to)),
    state.specialBusinessTimes
  );
};

const reduceAddSpecialBusinessTime = (state: ReservationSetting, action: SpecialBusinessTimeAddAction): ReservationSetting => {
  return new ReservationSetting(
    state.timeType,
    state.businessTimes,
    state.specialBusinessTimes.add(action.specialBusinessTime)
  );
};

const reduceSpecialBusinessDayType = (state: ReservationSetting, action: SpecialBusinessDayTypeSetAction): ReservationSetting => {
  const target: ReservationSpecialBusinessTime = state.specialBusinessTimes.findByIndex(action.index);
  const specialBusinessTime: ReservationSpecialBusinessTime = new ReservationSpecialBusinessTime(new ReservationBusinessDayTypeClass(action.dayType), target.date, target.from, target.to);
  return new ReservationSetting(
    state.timeType,
    state.businessTimes,
    state.specialBusinessTimes.replace(action.index, specialBusinessTime)
  );
};

const reduceSpecialBusinessDate = (state: ReservationSetting, action: SpecialBusinessDateSetAction): ReservationSetting => {
  const target: ReservationSpecialBusinessTime = state.specialBusinessTimes.findByIndex(action.index);
  const specialBusinessTime: ReservationSpecialBusinessTime = new ReservationSpecialBusinessTime(target.dayType, action.date, target.from, target.to);
  return new ReservationSetting(
    state.timeType,
    state.businessTimes,
    state.specialBusinessTimes.replace(action.index, specialBusinessTime)
  );
};

const reduceSpecialBusinessTimeFrom = (state: ReservationSetting, action: SpecialBusinessTimeFromSetAction): ReservationSetting => {
  const target: ReservationSpecialBusinessTime = state.specialBusinessTimes.findByIndex(action.index);
  const specialBusinessTime: ReservationSpecialBusinessTime = new ReservationSpecialBusinessTime(target.dayType, target.date, action.from, target.to);
  return new ReservationSetting(
    state.timeType,
    state.businessTimes,
    state.specialBusinessTimes.replace(action.index, specialBusinessTime)
  );
};

const reduceSpecialBusinessTimeTo = (state: ReservationSetting, action: SpecialBusinessTimeToSetAction): ReservationSetting => {
  const target: ReservationSpecialBusinessTime = state.specialBusinessTimes.findByIndex(action.index);
  const specialBusinessTime: ReservationSpecialBusinessTime = new ReservationSpecialBusinessTime(target.dayType, target.date, target.from, action.to);
  return new ReservationSetting(
    state.timeType,
    state.businessTimes,
    state.specialBusinessTimes.replace(action.index, specialBusinessTime)
  );
};

const reduceSpecialBusinessTimeDelete = (state: ReservationSetting, action: SpecialBusinessTimeDeleteAction): ReservationSetting => {
  return new ReservationSetting(state.timeType, state.businessTimes, state.specialBusinessTimes.delete(action.index));
};

export default reservationSettingReducer;
